
const initialState = () => ({
    isEdit: false,
    isRenew:false,
    contract_form: {
        CONTRACT_ID: "",
        CUSTOMER_ID: Number,
        CUSTOMER_NAME: "",
        CONTRACT_CATEGORY: "",
        CONTRACT_START_DATE: new Date(),
        CONTRACT_PERIOD: "",
        ORGANIZATION_NAME:"",
        CONTRACT_END_DATE: null,
        CUSTOMER_GROUP:"",
        CUSTOMER_TAX_ID: "",
        CUSTOMER_BRANCH: "",
        CUSTOMER_ADDRESS: "",
        PROVIDER_NAME:"",
        PROVIDER_EMAIL: "",
        CUSTOMER_SUBDISTRICT: "",
        CUSTOMER_DISTRICT: "",
        CUSTOMER_PROVINCE: "",
        CUSTOMER_ZIPCODE: "",
        PRICE_OPTION: "",
        ZONE_CODE:"",
        ISVAT: false,
        ISVAT2: false,
        VAT_VALUE: "",
        VAT_VALUE2: "",
        DOC_STATUS:"",
        IS_CONTRACT:true,
        MEMO: "",
        REMARK: "",

    },
    PRODUCT_LIST: [
        {
            PID: 0,
            QID: "",
            NAME: "",
            DETAIL: "",
            AMOUT: 1,
            UNIT: "",
            PRICE: 0,
            TOTAL_PRICE: 0
        },
    ]
});

const state = initialState()


const getters = {
    GET_CONTRACT_ENDDATE: state => state.contract_form.CONTRACT_END_DATE,
    GET_CONTRACT: state => state.contract_form,
    GET_SE_DATE: state => state.SE_DATE,
    GET_PRODUCT: state => state.PRODUCT_LIST,
    IS_EDIT: state => state.isEdit,
    IS_RENEW: state => state.isRenew,
}

const mutations = {
    SET_IS_EDIT(state, data) {
        state.isEdit = data
    },
    SET_IS_RENEW(state, data) {
        state.isRenew = data
    },
    SET_ALL_ELEMENT(state, data) {
        state.contract_form = Object.assign({}, data);
    },
    MERGE_ALL_ELEMENT(state, data) {
        let object1 = state.contract_form
        state.contract_form = Object.assign(object1, data);
    },
    SET_ELEMENT(state, data) {
        state.contract_form[data.key] = data.value;
    },
    SET_SE_DATE(state, data) {
        state.SE_DATE = data
    },
    SET_PRODUCT_LIST(state, data) {
        state.PRODUCT_LIST = data
    },
    RESET(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
            state[key] = newState[key]
        });
    },
}

const actions = {

    remove_product_list(context, items) {
        let data = context.state.PRODUCT_LIST
        const index = data.indexOf(items)
        data.splice(index, 1);
        context.commit('SET_PRODUCT_LIST', data)
    },
    add_product_list(context, items) {
        let data = context.state.PRODUCT_LIST
        data.push(items)
        data[data.length - 1].INDEX = parseInt(data.length) - 1
        context.commit('SET_PRODUCT_LIST', data)
    },
    reset_product_list(context, items) {
        context.commit('SET_PRODUCT_LIST', [{
            INDEX: 0,
            NAME: "",
            DETAIL: "",
            AMOUT: 1,
            UNIT: "",
            PRICE: 0,
            TOTAL_PRICE: 0
        }])
    },
    reset({ commit }) {
        commit('RESET');
    }
}
// Mutations

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}